import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import storage from 'helpers/storage';
import download from 'downloadjs';
import toastr from 'helpers/toastr';
import * as cmAction from 'actions/commons';

class ExcelDownButton extends Component {
  downloadExcel = async () => {
    const com = storage.get('company');
    const { cmAPI } = this.props;

    const { tradingInfo } = this.props;
    const { taxUnitSeq } = tradingInfo.data.companyTrading;

    let header = null;

    try {
      const params = {
        com,
        excel: {
          url: `/settlement/v1/trading/${taxUnitSeq}/download`,
          method: 'get'
        },
        excelResult: {
          excel: {
            requestid: com.user.id
          }
        }
      };

      await cmAPI.excelDownload(params);
      const { excelDownloadResult } = this.props;

      if (excelDownloadResult) {
        header = excelDownloadResult.headers['content-disposition'];
        header = header.split('=');

        download(excelDownloadResult.data, decodeURIComponent(header[1]));
        toastr('top-right', 'success', ' 엑셀파일 생성 완료 되었습니다.');
      }
    } catch (e) {
      const result = e.response;

      if (result && result.data) {
        const { status } = result;

        toastr('top-right', 'error', ` 엑셀파일 생성에 실패 하였습니다.(${String(status)})`);
      }
      console.log('###### ExcelDownLoad : ', e);
    }
  };

  render() {
    return (
      <div className="bottom-text" style={{ textAlign: 'right' }}>
        <Button inverted color="green" className="excel" onClick={this.downloadExcel}>
          엑셀 다운로드
        </Button>
      </div>
    );
  }
}

ExcelDownButton = connect(
  (state) => ({
    tradingInfo: state.settlement.tradingInfo,
    excelDownloadResult: state.commons.excelDownload
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        excelDownload: cmAction.ExcelDownload
      },
      dispatch
    )
  })
)(ExcelDownButton);

export default ExcelDownButton;
